import { useForm } from 'react-hook-form';
import { FormProvider, Table, TextField, Checkbox } from '../../../../../components';
import { Button, Container, Dialog, IconButton, Paper, Stack, Typography ,Box,  TextField as MuiTextField} from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import { useEffect, useState } from 'react';
import { yupResolver } from '@hookform/resolvers/yup';
import * as Yup from 'yup';
import { request, toast } from '../../../../../utils';
import { useLocation } from 'react-router-dom';
import { CustomButtonn } from '../../../../../components';

const initialDepartmentDataObj = {
  data: [],
  loading: false
};

const TABLE_COLUMNS = [
    {
      header: 'Department',
      accessor: (row) => {
        const status = row.status;
        return (
          <span
            style={{
              color: status === 'inactive' ? 'red' : 'black',
            }}
          >
            {`${row.name}`}
          </span>
        );
      },
    },
    {
      header: 'Status',
      accessor: 'status',
      sx: { textTransform: 'uppercase' }
    },
    {
      header: 'Created At',
      accessor: 'createdAt'
    }
  ];

export const DepartmentMaster = ({getDepartmentDropdown, setDepartmentMasterDialogue}) => {
  const [openQueryDialog, setOpenQueryDialog] = useState(false);
  const [departmentDataObj, setDepartmentDataObj] = useState(initialDepartmentDataObj);
  const [loading, setLoading] = useState(false);
  const [currentAction, setCurrentAction] = useState();
  const [selectedRecord, setSelectedRecord] = useState();
  const { pathname } = useLocation();
  const lastPathSegment = pathname.split('/').pop();
  const [input,setInput] = useState('')

  const methods = useForm({
    resolver: yupResolver(
      Yup.object().shape({
        name: Yup.string().required('Department is required')
      })
    ),
    defaultValues: { department: '' },
    mode: 'all'
  });
  const { handleSubmit, setValue, reset } = methods;

  useEffect(() => {
    if (selectedRecord) {
      setValue('name', selectedRecord.name);
    } else {
      reset();
    }
  }, [setValue, reset, selectedRecord]);

  const formSubmit = async (formValues) => {
    setLoading(true);
    let editFlag = false;
    if (selectedRecord && currentAction === 'edit') {
      editFlag = true;
    }
    const response = await request(editFlag ? '/employee-department-update' : '/employee-department-create', {
      method: editFlag ? 'PUT' : 'POST',
      params: editFlag ? selectedRecord._id : null,
      body: {
        name: formValues.name,
        status: formValues.status
      }
    });
    if (response?.success) {
      toast(`Successfully ${editFlag ? 'updated' : 'created'} department master`, { variant: 'success' });
      setSelectedRecord(response.data);
      setCurrentAction();
      getDepartmentDropdown()
      setDepartmentMasterDialogue(false)
      handleDepartmentList()
    } else {
      toast(`Failed to ${editFlag ? 'edit' : 'create'} department master`, { variant: 'error' });
    }
    setLoading(false);
  };


  const handleCancelRecord = async () => {
    setLoading(true);
    const response = await request('/employee-department-cancel', {
      method: 'DELETE',
      params: selectedRecord._id
    });
    if (response?.success) {
      toast('Successfully CancelLed department master', { variant: 'success' });
      setSelectedRecord();
      handleDepartmentList()
    } else {
      toast('Failed to Cancelled department master', { variant: 'error' });
    }
    setLoading(false);
  };


  const handleDeleteRecord = async () => {
    setLoading(true);
    const response = await request('/employee-department-delete', {
      method: 'DELETE',
      params: selectedRecord._id
    });
    if (response?.success) {
      toast('Successfully deleted department master', { variant: 'success' });
      setSelectedRecord();
      handleDepartmentList()
    } else {
      toast('Failed to delete department master', { variant: 'error' });
    }
    setLoading(false);
  };

  const handleDepartmentList= async () => {
    setOpenQueryDialog(true);
    setDepartmentDataObj({ loading: true });
    const response = await request('/employee-department-list', { method: 'GET' });
    if (response.success) {
      const filteredData = response.data.filter(item =>
        item.status === 'active' || item.status === 'inactive' || item.status === 'default'
      );
      setDepartmentDataObj({ loading: false, data: filteredData });
    } else {
      toast('Error in fetching data', { variant: 'error' });
      setDepartmentDataObj({ loading: false });
    }
  };

  useEffect(()=>{
    handleDepartmentList()
  },[])


  const handleChange=()=>{

  }
  return (
    <>
      <Paper sx={{
        p: 0, flex: 1, borderRadius: 0, boxShadow: 'none',
        width: '100%',
        height: 'auto'
      }}>
        <Container
          sx={{
            mt: 1,
            border: '0px solid',
            borderColor: 'grey.300',
            borderRadius: 1,
            width: '100%',
            maxWidth: 'none',
            minWidth: "100%",
            boxSizing: 'border-box',

          }}
        >
          <FormProvider methods={methods} onSubmit={handleSubmit(formSubmit)}>
            <Stack
              direction="row"
              spacing={2}
              justifyContent="space-between"
              alignItems="center"
              sx={{
                mb: 1,
                borderBottom: '0px solid',
                borderColor: 'grey.300'
              }}
            >
              <Typography color="primary" variant="h3" sx={{ fontWeight: 600 }}>
                Employee Department Master
              </Typography>
              <Stack direction="row" justifyContent="flex-end" sx={{ mb: 3 }} spacing={1}>
                <CustomButtonn
                  id={`${lastPathSegment}Write`}
                  variant="contained"
                  disabled={['edit', 'new'].includes(currentAction)}
                  onClick={() => {
                    setSelectedRecord();
                    setCurrentAction('new');
                    reset();
                  }}
                >
                  New
                </CustomButtonn>
                <CustomButtonn
                  id={`${lastPathSegment}Update`}
                  variant="contained"
                  disabled={['new', 'edit'].includes(currentAction) || !selectedRecord}
                  onClick={() => setCurrentAction('edit')}
                >
                  Edit
                </CustomButtonn>
                <CustomButtonn
                  id={"Submit"}
                  type="submit"
                  variant="contained"
                  disabled={!['edit', 'new'].includes(currentAction) || loading}
                >
                  Save
                </CustomButtonn>
                <CustomButtonn
                  id={"Cancel"}
                  variant="contained"
                  disabled={['edit', 'new'].includes(currentAction) || loading}
                  onClick={() => {
                    setCurrentAction();
                    handleCancelRecord()
                  }}
                >
                  Cancel
                </CustomButtonn>
                <CustomButtonn
                  id={`isSuperAdmin`}
                  variant="contained"
                  disabled={!selectedRecord || ['new', 'edit'].includes(currentAction) || loading}
                  onClick={handleDeleteRecord}
                >
                  Delete
                </CustomButtonn>
                <CustomButtonn
                  id={`${lastPathSegment}Read`}
                  variant="contained"
                  disabled={['new', 'edit'].includes(currentAction)}
                >
                  Query
                </CustomButtonn>
                <CustomButtonn id={`${lastPathSegment}Print`} variant="contained" disabled={!selectedRecord || currentAction}>
                  Print
                </CustomButtonn>
                <CustomButtonn
                  id={"Exit"}
                  variant="contained"
                  onClick={() => {
                    setCurrentAction('');
                  }}
                >Exit</CustomButtonn>
              </Stack>
            </Stack>
            <Stack spacing={2} sx={{ marginBottom: "1%" }}>
            <Box sx={{ border: '1px solid gray', padding: 2, borderRadius: '8px',width: '100%' ,boxShadow: '0px 2px 10px #0099ff' }}>
              <Stack direction="row" spacing={2} alignItems="center">
                <Typography sx={{ flex: 0.25, fontSize: '1.4rem', fontWeight: 700 }}>Department Name</Typography>
                <TextField
                  name="name"
                  sx={{ flex: 1, border: currentAction ? "0.5px solid red" : "" }}
                  inputProps={{ sx: { fontSize: '1.6rem' } }}
                  placeholder="Enter Department Name"
                  fullWidth
                  disabled={!['new', 'edit'].includes(currentAction)}
                />
              </Stack>
        <Stack
          padding={0.2}
          direction="row"
          spacing={2}
          alignItems="center"
          justifyContent="space-between"
          borderBottom="1px solid"
          borderColor="grey.300"
          marginTop="2%"
        >
          <Typography variant="h5" fontWeight="bold">
            Department List
          </Typography>
        </Stack>
        <Table
          sx={{ mt: 0.5 }}
          columns={TABLE_COLUMNS}
          data={departmentDataObj.data || []}
          loading={departmentDataObj.loading}
          onRowClick={(row) => {
            setOpenQueryDialog(false);
            setSelectedRecord(row);
          }}
        />
              </Box>
            </Stack>
          </FormProvider>
        </Container>
      </Paper>
    </>
  );
};
